





























import { StringProp } from '@/util/prop-decorators';
import { Component, Vue } from 'vue-property-decorator';
import { AppCustomerViessmannInstallationTableFragment } from '../../../components/viessmann-installation-table/__generated__/AppCustomerViessmannInstallationTableFragment';
import query from './view.gql';
import {
  AppCustomerViessmannApiAvailableInstallationsViewQuery,
  AppCustomerViessmannApiAvailableInstallationsViewQueryVariables,
} from './__generated__/AppCustomerViessmannApiAvailableInstallationsViewQuery';

@Component({
  apollo: {
    customers: {
      query,
      fetchPolicy: 'network-only',
      variables(this: AvailableInstallationsView): AppCustomerViessmannApiAvailableInstallationsViewQueryVariables {
        return { customerId: this.customerId, viessmannApiId: this.vendorApiId };
      },
    },
  },
  data() {
    return { customers: undefined };
  },
})
export default class AvailableInstallationsView extends Vue {
  @StringProp(true)
  private readonly customerId!: string;

  @StringProp(true)
  private readonly vendorApiId!: string;

  private readonly customers?: AppCustomerViessmannApiAvailableInstallationsViewQuery['customers'];

  private get installations(): AppCustomerViessmannInstallationTableFragment[] {
    return this.customers?.first.viessmannApis.first.installations?.items ?? [];
  }
}
